import emailjs from "@emailjs/browser";

const SERVICE_ID          = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID         = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PAYMENT_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_PAYMENT_TEMPLATE_ID || process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY          = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const itemsTable = (items = []) =>
  `<table style="width:100%;border-collapse:collapse;margin:16px 0;">
    <thead>
      <tr style="background:#f5f0eb;">
        <th style="padding:10px 12px;text-align:left;font-size:13px;color:#555;border-bottom:2px solid #e8ddd5;">Product</th>
        <th style="padding:10px 12px;text-align:center;font-size:13px;color:#555;border-bottom:2px solid #e8ddd5;">Qty</th>
        <th style="padding:10px 12px;text-align:right;font-size:13px;color:#555;border-bottom:2px solid #e8ddd5;">Price</th>
      </tr>
    </thead>
    <tbody>
      ${items.map((i) => `
        <tr style="border-bottom:1px solid #f0ebe6;">
          <td style="padding:10px 12px;font-size:13px;color:#333;">${i.name || "Product"}</td>
          <td style="padding:10px 12px;text-align:center;font-size:13px;color:#333;">${i.qty || i.quantity || 1}</td>
          <td style="padding:10px 12px;text-align:right;font-size:13px;color:#333;">₹${Number(i.price || 0).toLocaleString("en-IN")}</td>
        </tr>`).join("")}
    </tbody>
  </table>`;

const wrapper = (body) =>
  `<div style="font-family:'Segoe UI',Arial,sans-serif;max-width:580px;margin:0 auto;background:#fff;border-radius:12px;overflow:hidden;box-shadow:0 4px 20px rgba(0,0,0,0.1);">
    <div style="background:linear-gradient(135deg,#984A1F 0%,#7a3b19 100%);padding:32px;text-align:center;">
      <h1 style="color:#fff;margin:0;font-size:24px;letter-spacing:1px;font-weight:700;">AarnaSignatures</h1>
      <p style="color:rgba(255,255,255,0.75);margin:6px 0 0;font-size:12px;letter-spacing:2px;">PREMIUM FRAGRANCES</p>
    </div>
    <div style="padding:32px;">${body}</div>
    <div style="background:#faf8f6;padding:20px 32px;text-align:center;border-top:1px solid #f0ebe6;">
      <p style="color:#aaa;font-size:11px;margin:0;">© ${new Date().getFullYear()} AarnaSignatures · All rights reserved</p>
      <p style="color:#bbb;font-size:11px;margin:4px 0 0;">Questions? Contact us at aarnasingnature.payments@gmail.com</p>
    </div>
  </div>`;

const buildPaymentEmail = (order) => {
  const orderId   = (order.orderId || order.razorpayOrderId || order.id || "").slice(0, 20);
  const paymentId = order.paymentId || "";
  const name      = order.name || "Customer";
  const subtotal  = Number(order.subtotal || 0).toLocaleString("en-IN");
  const gst       = Number(order.gst || 0).toLocaleString("en-IN");
  const total     = Number(order.total || 0).toLocaleString("en-IN");
  const orderDate = new Date(order.createdAt || Date.now()).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });
  const address   = [order.houseNo, order.street, order.area].filter(Boolean).join(", ");

  return wrapper(`
    <div style="text-align:center;margin-bottom:28px;">
      <div style="font-size:52px;">✅</div>
      <h2 style="color:#2e7d32;margin:8px 0 4px;font-size:22px;">Payment Successful!</h2>
      <p style="color:#777;margin:0;font-size:14px;">Your order has been confirmed</p>
    </div>

    <p style="color:#444;font-size:15px;margin:0 0 6px;">Hi <strong>${name}</strong>,</p>
    <p style="color:#555;font-size:14px;line-height:1.6;margin:0 0 24px;">
      Thank you for your purchase! Your payment has been received and your order is now being prepared.
    </p>

    <div style="background:#f0faf4;border-radius:8px;padding:16px 20px;margin-bottom:20px;border-left:4px solid #2e7d32;">
      <p style="margin:0 0 4px;font-size:12px;color:#777;text-transform:uppercase;letter-spacing:1px;">Payment Confirmed</p>
      <p style="margin:0;font-size:20px;font-weight:700;color:#2e7d32;">₹${total}</p>
    </div>

    <div style="background:#faf8f6;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
      <table style="width:100%;font-size:13px;">
        <tr><td style="color:#777;padding:4px 0;">Order ID</td><td style="text-align:right;font-weight:700;color:#984A1F;">#${orderId}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Payment ID</td><td style="text-align:right;color:#333;font-family:monospace;font-size:12px;">${paymentId}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Order Date</td><td style="text-align:right;color:#333;">${orderDate}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Payment Status</td><td style="text-align:right;"><span style="background:#e8f5e9;color:#2e7d32;padding:2px 10px;border-radius:12px;font-weight:600;font-size:12px;">PAID</span></td></tr>
      </table>
    </div>

    <div style="background:#faf8f6;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
      <p style="margin:0 0 8px;font-size:13px;font-weight:700;color:#333;">Delivery Address</p>
      <p style="margin:0;font-size:13px;color:#555;line-height:1.7;">
        <strong>${name}</strong><br/>
        ${address ? address + "<br/>" : ""}
        ${order.city || ""}${order.state ? ", " + order.state : ""}${order.pincode ? " - " + order.pincode : ""}<br/>
        📞 ${order.phone || ""}
      </p>
    </div>

    <p style="font-size:14px;font-weight:700;color:#333;margin:24px 0 4px;">Items Ordered</p>
    ${itemsTable(order.items)}

    <div style="background:#faf8f6;border-radius:8px;padding:14px 20px;margin-top:4px;">
      <div style="display:flex;justify-content:space-between;font-size:13px;color:#777;margin-bottom:6px;">
        <span>Subtotal</span><span>₹${subtotal}</span>
      </div>
      <div style="display:flex;justify-content:space-between;font-size:13px;color:#777;margin-bottom:6px;">
        <span>GST (18%)</span><span>₹${gst}</span>
      </div>
      <div style="display:flex;justify-content:space-between;font-size:13px;color:#777;margin-bottom:6px;">
        <span>Delivery</span><span style="color:#2e7d32;font-weight:600;">FREE</span>
      </div>
      <div style="border-top:2px solid #e8ddd5;margin-top:10px;padding-top:10px;display:flex;justify-content:space-between;">
        <span style="font-size:15px;font-weight:700;color:#333;">Total Paid</span>
        <span style="font-size:15px;font-weight:700;color:#2e7d32;">₹${total}</span>
      </div>
    </div>

    <div style="background:#fff8f0;border-radius:8px;padding:20px;margin-top:24px;text-align:center;border:1px solid #f5e6d8;">
      <p style="color:#984A1F;font-weight:700;margin:0 0 12px;font-size:15px;">Track your order anytime 📦</p>
      <a href="https://aarnastores-64786.web.app/my-orders" style="background:linear-gradient(135deg,#984A1F,#7a3b19);color:#fff;padding:12px 28px;border-radius:25px;text-decoration:none;font-weight:600;font-size:13px;display:inline-block;">
        View My Orders
      </a>
    </div>
  `);
};

const buildShippedEmail = (order) => {
  const orderId   = (order.orderId || order.id || "").slice(0, 16);
  const name      = order.name || "Customer";
  const total     = Number(order.total || 0).toLocaleString("en-IN");
  const orderDate = new Date(order.createdAt || Date.now()).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  const trackingBlock = (order.trackingId || order.courierPartner || order.estimatedDelivery)
    ? `<div style="background:#f0f7ff;border-radius:8px;padding:16px 20px;margin:20px 0;border-left:4px solid #2196f3;">
        <p style="margin:0 0 4px;font-size:13px;font-weight:700;color:#1565c0;">Tracking Information</p>
        ${order.trackingId        ? `<p style="margin:4px 0;font-size:13px;color:#333;"><strong>Tracking ID:</strong> ${order.trackingId}</p>` : ""}
        ${order.courierPartner    ? `<p style="margin:4px 0;font-size:13px;color:#333;"><strong>Courier:</strong> ${order.courierPartner}</p>` : ""}
        ${order.courierContact    ? `<p style="margin:4px 0;font-size:13px;color:#333;"><strong>Courier Contact:</strong> ${order.courierContact}</p>` : ""}
        ${order.estimatedDelivery ? `<p style="margin:4px 0;font-size:13px;color:#333;"><strong>Est. Delivery:</strong> ${order.estimatedDelivery}</p>` : ""}
      </div>`
    : "";

  const trackBtn = order.trackingLink
    ? `<div style="text-align:center;margin:24px 0;">
        <a href="${order.trackingLink}" style="background:linear-gradient(135deg,#984A1F,#7a3b19);color:#fff;padding:13px 32px;border-radius:25px;text-decoration:none;font-weight:600;font-size:14px;display:inline-block;">🚚 Track Your Order</a>
      </div>`
    : "";

  return wrapper(`
    <div style="text-align:center;margin-bottom:24px;">
      <div style="font-size:48px;">🚚</div>
      <h2 style="color:#984A1F;margin:8px 0 4px;font-size:22px;">Your Order is on its Way!</h2>
      <p style="color:#777;margin:0;font-size:14px;">Your package has been shipped</p>
    </div>

    <p style="color:#444;font-size:15px;margin:0 0 20px;">Hi <strong>${name}</strong>,</p>
    <p style="color:#555;font-size:14px;line-height:1.6;margin:0 0 20px;">Your order has been shipped and is on its way to you.</p>

    <div style="background:#faf8f6;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
      <table style="width:100%;font-size:13px;">
        <tr><td style="color:#777;padding:4px 0;">Order ID</td><td style="text-align:right;font-weight:700;color:#984A1F;">#${orderId}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Order Date</td><td style="text-align:right;color:#333;">${orderDate}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Deliver To</td><td style="text-align:right;color:#333;">${order.city || ""}</td></tr>
      </table>
    </div>

    ${trackingBlock}
    ${trackBtn}

    <p style="font-size:14px;font-weight:700;color:#333;margin:24px 0 4px;">Order Summary</p>
    ${itemsTable(order.items)}
    <div style="text-align:right;padding:8px 0;border-top:2px solid #f0ebe6;">
      <span style="font-size:16px;font-weight:700;color:#2e7d32;">Total Paid: ₹${total}</span>
    </div>

    <div style="background:#fff8f0;border-radius:8px;padding:16px;margin-top:24px;text-align:center;border:1px solid #f5e6d8;">
      <p style="color:#984A1F;font-weight:600;margin:0;font-size:14px;">Thank you for shopping with AarnaSignatures! 💛</p>
    </div>
  `);
};

const buildDeliveredEmail = (order) => {
  const orderId   = (order.orderId || order.id || "").slice(0, 16);
  const name      = order.name || "Customer";
  const total     = Number(order.total || 0).toLocaleString("en-IN");
  const orderDate = new Date(order.createdAt || Date.now()).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" });

  return wrapper(`
    <div style="text-align:center;margin-bottom:24px;">
      <div style="font-size:48px;">🎉</div>
      <h2 style="color:#2e7d32;margin:8px 0 4px;font-size:22px;">Order Delivered Successfully!</h2>
      <p style="color:#777;margin:0;font-size:14px;">Your package has arrived</p>
    </div>

    <p style="color:#444;font-size:15px;margin:0 0 20px;">Hi <strong>${name}</strong>,</p>
    <p style="color:#555;font-size:14px;line-height:1.6;margin:0 0 20px;">Your order has been delivered! We hope you're loving your new fragrance.</p>

    <div style="background:#faf8f6;border-radius:8px;padding:16px 20px;margin-bottom:20px;">
      <table style="width:100%;font-size:13px;">
        <tr><td style="color:#777;padding:4px 0;">Order ID</td><td style="text-align:right;font-weight:700;color:#984A1F;">#${orderId}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Order Date</td><td style="text-align:right;color:#333;">${orderDate}</td></tr>
        <tr><td style="color:#777;padding:4px 0;">Delivered On</td><td style="text-align:right;color:#2e7d32;font-weight:600;">${new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</td></tr>
      </table>
    </div>

    <p style="font-size:14px;font-weight:700;color:#333;margin:24px 0 4px;">What You Ordered</p>
    ${itemsTable(order.items)}
    <div style="text-align:right;padding:8px 0;border-top:2px solid #f0ebe6;">
      <span style="font-size:16px;font-weight:700;color:#2e7d32;">Total Paid: ₹${total}</span>
    </div>

    <div style="background:#fff8f0;border-radius:8px;padding:20px;margin-top:24px;text-align:center;border:1px solid #f5e6d8;">
      <p style="color:#984A1F;font-weight:700;margin:0 0 6px;font-size:15px;">Enjoying your fragrance? ⭐</p>
      <p style="color:#777;font-size:13px;margin:0 0 14px;">Leave a review — it helps other customers!</p>
      <a href="https://aarnastores-64786.web.app/my-orders" style="background:linear-gradient(135deg,#984A1F,#7a3b19);color:#fff;padding:11px 28px;border-radius:25px;text-decoration:none;font-weight:600;font-size:13px;display:inline-block;">Leave a Review</a>
    </div>
  `);
};

const send = async (templateId, toEmail, toName, subject, html) => {
  console.log("EmailJS sending to:", toEmail, "| SERVICE_ID:", SERVICE_ID, "| TEMPLATE_ID:", templateId);
  await emailjs.send(
    SERVICE_ID,
    templateId,
    {
      to_email:   toEmail,
      user_email: toEmail,
      email:      toEmail,
      to_name:    toName,
      from_name:  "AarnaSignatures",
      subject,
      message:    html,
    },
    PUBLIC_KEY
  );
};

export const sendPaymentEmail = async (order) => {
  if (!SERVICE_ID || !PAYMENT_TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS keys not configured in .env");
    return { success: false, error: "EmailJS not configured" };
  }
  try {
    const orderId = (order.orderId || order.razorpayOrderId || order.id || "").slice(0, 12);
    await send(
      PAYMENT_TEMPLATE_ID,
      order.email,
      order.name || "Customer",
      `Order Confirmed #${orderId} — Payment Received ✅`,
      buildPaymentEmail(order)
    );
    return { success: true };
  } catch (err) {
    console.error("Payment email error:", err);
    return { success: false, error: err.message };
  }
};

export const sendOrderEmail = async (order, type) => {
  if (!SERVICE_ID || !TEMPLATE_ID || !PUBLIC_KEY) {
    console.warn("EmailJS keys not configured in .env");
    return { success: false, error: "EmailJS not configured" };
  }
  try {
    const isShipped = type === "shipped";
    const orderId   = (order.orderId || order.id || "").slice(0, 12);
    await send(
      TEMPLATE_ID,
      order.email,
      order.name || "Customer",
      isShipped
        ? `Your Order #${orderId} has been Shipped! 🚚`
        : `Your Order #${orderId} has been Delivered! 🎉`,
      isShipped ? buildShippedEmail(order) : buildDeliveredEmail(order)
    );
    return { success: true };
  } catch (err) {
    console.error("Email send error:", err);
    return { success: false, error: err.message };
  }
};
